import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=772fe6f6"
import script from "./CardList.vue?vue&type=script&lang=ts"
export * from "./CardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports